export enum ItemBroadcastStatus {
    Created = 0,
    Updated = 1,
    Deleted = 2,
    Locked = 3,
    Unlocked = 4,
    ExternalResource = 5
}

export interface ItemStatusBroadcast {
    listId: string;
    itemId: number;
    accountId?: string;
    externalResourceUrl?: string;
    status: ItemBroadcastStatus;
}